import SurfaceCard from "@/components/primitives/SurfaceCard";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import RichTextRenderer from "@/components/ui/rich-text-renderer";
import { SectionHead } from "@/components/organization/kit";

interface BrandStoryProps {
  paragraphs: string[];
  pullQuote?: string;
  pullQuoteAuthor?: string;
}

const initials = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("") || "—";

const BrandStory = ({ paragraphs, pullQuote, pullQuoteAuthor }: BrandStoryProps) => {
  const hasStory = paragraphs.filter(Boolean).length > 0;

  return (
    <div className="flex flex-col gap-[22px]">
      {hasStory && (
        <SurfaceCard padding="lg" className="rounded-2xl">
          <div className="mx-auto max-w-[760px]">
            <SectionHead kicker="Our story" title="How the team was built" />
            <div className="space-y-4">
              {paragraphs.filter(Boolean).map((paragraph, index) => (
                <RichTextRenderer
                  key={index}
                  content={paragraph}
                  className="text-base leading-[1.7] text-ink-700"
                />
              ))}
            </div>
          </div>
        </SurfaceCard>
      )}

      {pullQuote && (
        <div className="rounded-2xl border border-border bg-secondary p-8">
          <div className="mx-auto max-w-[760px]">
            <div className="font-display text-[44px] leading-none text-primary" style={{ height: 22 }}>
              &ldquo;
            </div>
            <div className="mt-2 font-display text-[23px] font-medium leading-[1.4] text-ink-900">
              <RichTextRenderer
                content={pullQuote}
                className="prose-p:text-inherit prose-p:text-[length:inherit] prose-p:font-medium prose-p:leading-[1.4]"
              />
            </div>
            {pullQuoteAuthor && (
              <div className="mt-5 flex items-center gap-3">
                <Avatar className="h-9 w-9">
                  <AvatarFallback className="bg-primary-tint text-xs font-semibold text-primary-pressed">
                    {initials(pullQuoteAuthor)}
                  </AvatarFallback>
                </Avatar>
                <div className="text-sm font-semibold text-ink-900">{pullQuoteAuthor}</div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BrandStory;
